import applogger from '@applogger'
import grapqhQLQueries from './graphql-queries'

const promises = {}

function retreiveCacheContentList(state, { type, limit, latest, featured, articleCategory }) {
  // Attempt to load a cache copy of the specific content-list from the VueJS Rest Endpoint (/vuejs/content-list)
  latest = latest ? 'true' : 'false'
  featured = featured ? 'true' : 'false'
  const category = articleCategory ?? null

  let uri = state.registry.getServiceEndpoint('datastore') + `/vuejs/content-list/${type}?limit=${limit}&latest=${latest}&featured=${featured}`
  if (category !== null) {
    uri += `&article_category=${category}`
  }

  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    redirect: 'follow',
    credentials: 'omit'
  }
  return fetch(uri, options)
    .then(resp => {
      if (resp.ok && resp.status) {
        return resp.json()
      }
      throw new Error('No REST Response or Invalid REST Response')
    })
}

function loadWines(context, options) {
  options = {
    key: 'latest-wines',
    latest: true,
    featured: false,
    limit: 10,
    filestore: 'website',
    ...options
  }

  const ContentListKey = `${options.key}-${options.limit}`
  const __loader = () => {
    const filestorename = (typeof options.filestore === 'string') ? options.filestore : options.filestorename
    return retreiveCacheContentList(context.state, { type: 'wines', ...options })
      .catch(_err => {
        return context.getters.getGraphQLClient().query({
          query: grapqhQLQueries,
          opName: 'getWines',
          variables: {
            limit: options.limit,
            featured: options.featured,
            latest: options.latest
          }
        })
      })
      .then((resp) => {
        if (resp && resp.data && resp.data.wines) {
          context.dispatch('adhocstore', { key: ContentListKey, data: resp.data.wines })
          const imageLoaders = resp.data.wines.reduce((acc, wine) => {
            if (wine && wine.images && wine.images[0] && wine.images[0].image) {
              return [...acc, { ...wine.images[0].image, preset: 'wineproductteaser' }, { ...wine.images[0].image, preset: 'wineproductteaser__lowres' }]
            }
            return acc
          }, [])

          // This ImageLoaders is an Object that will collect a number of files and then process the
          // presigned url load together - reducing the number of fusws requests made
          if (context.imageLoaders !== undefined) {
            context.imageLoaders.add(imageLoaders)
            return Promise.resolve([resp.data.wines, undefined])
          }
          else {
            return Promise.all([
              resp.data.wines,
              context.dispatch('filestore/getFileURLBulk', { files: imageLoaders, filestorename: filestorename || 'website' })
            ])
          }
        }
        throw new Error()
      })
      .then(([wines, _files]) => {
        // Object.values(_files).forEach(file => applogger.debug(`Wine Content List File prefetched: ${file}`))
        delete promises[ContentListKey]
        applogger.debug(`Wine Content List Loaded: ${ContentListKey}`)
        return wines
      })
  }
  return context.dispatch('promisePool', {
    name: `wines-${options.limit}-${options.latest}-${options.featured}`,
    resolve: __loader
  })
}

function loadNews(context, options) {
  options = {
    key: 'content-list-article',
    latest: true,
    featured: false,
    limit: 10,
    filestore: 'website',
    articleCategory: '_all',
    ...options
  }
  const ContentListKey = `${options.key}-${options.limit}-${options.articleCategory}`
  const filestorename = (typeof options.filestore === 'string') ? options.filestore : options.filestorename

  const __loader = () => {
    return retreiveCacheContentList(context.state, { type: 'article', ...options })
      .catch(_err => {
        return context.getters.getGraphQLClient().query({
          query: grapqhQLQueries,
          opName: 'getNews',
          variables: {
            limit: options.limit,
            featured: options.featured,
            latest: options.latest
          }
        })
      })
      .then((resp) => {
        if (resp && resp.data && resp.data.newslist) {
          context.commit('STORE_ADHOC_STORAGE', { key: ContentListKey, data: resp.data.newslist })
          const imageLoaders = resp.data.newslist.reduce((acc, news) => {
            if (news && news.assets && news.assets.thumbnail && news.assets.thumbnail.filepath) {
              return [...acc, { ...news.assets.thumbnail, preset: 'newsteaser' }, { ...news.assets.thumbnail, preset: 'newsteaser__lowres' }]
            }
            return acc
          }, [])

          if (context.imageLoaders !== undefined) {
            context.imageLoaders.add(imageLoaders)
            return Promise.resolve([resp.data.newslist, undefined])
          }
          else {
            return Promise.all([
              resp.data.newslist,
              context.dispatch('filestore/getFileURLBulk', { files: imageLoaders, filestorename: filestorename || 'website' })
            ])
          }
        }
        throw new Error()
      })
      .then(([news, _files]) => {
        delete promises[ContentListKey]
        applogger.debug(`Article Content List Loaded: ${ContentListKey}`)
        return news
      })
  }

  return context.dispatch('promisePool', {
    name: `news-${options.limit}-${options.latest}-${options.featured}-${options.articleCategory}`,
    resolve: __loader
  })
}

function loadProducts(context, options) {
  options = {
    key: 'content-list-productrs',
    latest: true,
    featured: false,
    limit: 10,
    filestore: 'website',
    ...options
  }
  const ContentListKey = `${options.key}-${options.limit}`

  const __loader = () => {
    return retreiveCacheContentList(context.state, { type: 'products', ...options })
      .catch(_err => {
        return context.getters.getGraphQLClient().query({
          query: grapqhQLQueries,
          opName: 'getProducts',
          variables: {
            limit: options.limit,
            featured: options.featured,
            latest: options.latest
          }
        })
      })
      .then((resp) => {
        if (resp && resp.data && resp.data.products) {
          context.commit('STORE_ADHOC_STORAGE', { key: ContentListKey, data: resp.data.products })
          return resp.data.products
        }
        throw new Error()
      })
  }

  return context.dispatch('promisePool', {
    name: `products-${options.limit}-${options.latest}-${options.featured}`,
    resolve: __loader
  })
}

export default {
  loadProducts,
  loadWines,
  loadNews
}
